"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var InputBase_1 = __importDefault(require("@mui/material/InputBase"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var react_1 = __importStar(require("react"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var icons_1 = __importDefault(require("./icons"));
var makeInputStyles_1 = __importDefault(require("./makeInputStyles"));
var Input = function (_a) {
    var error = _a.error, iconType = _a.iconType, id = _a.id, isAnswered = _a.isAnswered, isAutoFilledActive = _a.isAutoFilledActive, isSafari = _a.isSafari, isOtherOption = _a.isOtherOption, multiline = _a.multiline, placeholder = _a.placeholder, rows = _a.rows, onChange = _a.onChange, valueTransform = _a.valueTransform, value = _a.value, disabled = _a.disabled, experimentName = _a.experimentName, otherProps = __rest(_a, ["error", "iconType", "id", "isAnswered", "isAutoFilledActive", "isSafari", "isOtherOption", "multiline", "placeholder", "rows", "onChange", "valueTransform", "value", "disabled", "experimentName"]);
    var _b = react_1.default.useState(value), currentValue = _b[0], setCurrentValue = _b[1];
    (0, react_1.useEffect)(function () {
        setCurrentValue(value);
    }, [value]);
    var isValid = error === true ? false : isAnswered;
    var endAdornment;
    var styles = (0, makeInputStyles_1.default)({
        isAnswered: isAnswered,
        isOtherOption: isOtherOption,
        isAutoFilledActive: isAutoFilledActive,
        isSafari: isSafari,
        error: error === true,
    });
    if ((isValid || error) && multiline !== true) {
        var validationIconType = isValid ? 'valid' : 'invalid';
        var ValidationIconComponent = icons_1.default[validationIconType];
        endAdornment = ((0, jsx_runtime_1.jsx)(InputAdornment_1.default, { position: "end", "data-testid": "endAdornment-".concat(validationIconType), css: styles.adornmentEnd, children: (0, jsx_runtime_1.jsx)(ValidationIconComponent, { viewBox: "2 2 20 20", css: styles.validationIcon }) }));
    }
    var startAdornment;
    if (iconType) {
        var IconComponent = icons_1.default[iconType];
        startAdornment = ((0, jsx_runtime_1.jsx)(InputAdornment_1.default, { css: styles.adornmentStart, position: "start", "data-testid": "startAdornment", children: (0, jsx_runtime_1.jsx)(IconComponent, {}) }));
    }
    var handleChange = function (e) {
        var rawValue = e.target.value;
        var newValue = valueTransform ? valueTransform(rawValue) : rawValue;
        onChange({ id: id, value: newValue });
        setCurrentValue(newValue);
    };
    return ((0, jsx_runtime_1.jsx)(InputBase_1.default, __assign({ id: id, placeholder: placeholder, css: styles.input, endAdornment: endAdornment, multiline: multiline, onChange: handleChange, startAdornment: startAdornment, value: currentValue, rows: rows, disabled: disabled }, otherProps)));
};
Input.defaultProps = defaultProps_1.default;
exports.default = Input;
//# sourceMappingURL=Input.js.map